import { useQuery } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { agentsAxios, skillsAuthHeaders } from '@/services/skills';
import { AGENT_RUNS_ENDPOINT, normalizeAgentRunListResponse } from '@/services/reports';
import type { AgentRunListResponse } from '@/services/reports';

export function useAgentRuns(opts: { limit?: number } = {}) {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);
  const limit = opts.limit ?? 60;

  return useQuery<AgentRunListResponse>({
    queryKey: ['agent-runs', orgId, limit],
    queryFn: async () => {
      const { data } = await agentsAxios.get(AGENT_RUNS_ENDPOINT, {
        params: { limit },
        headers: skillsAuthHeaders(),
      });
      return normalizeAgentRunListResponse(data);
    },
    enabled: !!orgId,
    staleTime: 30_000,
    retry: false,
    // Keep current runs visible while a larger "Load more" window refetches — no flash.
    placeholderData: (prev) => prev,
  });
}
